/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Snackbar, Menu, MenuItem, Card, CardContent, Divider, Chip } from '@mui/material';
import Typography from '@mui/material/Typography';
import axios from 'lib/axios';
import Comment from '../../assets/static_images/comment.svg';
import Reacts from '../../components/Reacts';
import CreateComment from 'components/comment/CreateComment';
import ThreeDot from '../../assets/static_images/threedot.svg';
import Button from '@mui/material/Button';
import Like from '../../assets/static_images/like.svg';
import Love from '../../assets/static_images/love.svg';
import Haha from '../../assets/static_images/haha.svg';
import Wow from '../../assets/static_images/wow.svg';
import Sad from '../../assets/static_images/sad.svg';
import Angry from '../../assets/static_images/angry.svg';
import Blank from '../../assets/static_images/blank.svg';
import PdfIcon from '../../assets/static_images/pdficon.svg';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import PolicyViewers from 'components/modals/PolicyViewers';
import CreatePolicy from 'components/modals/Policy';
import { Alert } from '@mui/lab';
import DeleteModal from 'components/modals/DeleteModal';
import { Box, Stack, IconButton } from '@mui/material';
import FileDownload from 'js-file-download';
import ViewReactModal from 'components/modals/ViewReactModal';
import { Avatar, AvatarGroup } from '@mui/material';
import PolicyCommentBox from './PolicyCommentBox';
import { socket } from 'socket';
import HasPermission from 'utils/HasPermission';
import { Modal } from '@mui/material';
import { convertDateAndTime, downloadFile } from 'Helpers';
import UserAvatarComponent from 'components/UserAvatarComponent';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 6,
    backgroundColor: theme.palette.grey[200],
    '& .MuiLinearProgress-bar': {
        borderRadius: 6,
        backgroundColor: '#1E7C88'
    }
}));

const StyledCard = styled(Card)(({ theme }) => ({
    marginBottom: theme.spacing(2.5),
    borderRadius: 12,
    border: '1px solid #1E7C8840',
    boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
}));

const AttachmentBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2.5),
    border: '1px solid #e8e8e8',
    borderRadius: 12,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        backgroundColor: '#f8f9fa',
        borderColor: '#1E7C88',
        transform: 'translateY(-1px)'
    }
}));

const Policy = ({ policy, reacts, setPolicies, formSidebar = false, lastPostRef, index, policies }) => {
    const [policyUsers, setPolicyUsers] = useState(
        policy.policy_users.map((item) => {
            return { ...item.user, seen: item.seen, seen_at: item.updatedAt };
        })
    );
    const [attendenceCount, setAttendenceCount] = useState(() => {
        let count = 0;
        policyUsers.map((user) => {
            if (user.seen == true) {
                count++;
            }
        });
        return count;
    });

    const [percent, setPercent] = useState(() => {
        return (attendenceCount / policyUsers.length) * 100;
    });
    const [openViewReactModal, setOpenViewReactModal] = useState(false);

    useEffect(() => {
        setPercent((attendenceCount / policyUsers.length) * 100);
    }, [attendenceCount, policyUsers.length]);

    async function submitResponse(response) {
        axios
            .post(`/policies/response`, {
                policy_id: policy.policy_id,
                response: response
            })
            .then(({ data }) => {
                if (data.success) {
                    setAttendenceCount((attendenceCount) => attendenceCount + 1);
                }
            })
            .catch((err) => console.log(err));
    }

    const [content, setContent] = useState('');
    const [contentUrl, setContentUrl] = useState('');
    const [user, setUser] = useState(policy.user);
    const [showParticipants, setShowParticipants] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [reactOpen, setReactOpen] = useState(false);
    const [reacted, setReacted] = useState(false);
    const [reaction, setReaction] = useState(null);
    const [reactionImg, setReactionImg] = useState(Blank);
    const [commentOpen, setCommentOpen] = useState(false);
    const [reactCount, setReactCount] = useState(Number(policy.policyReactCount));
    const [comments, setComments] = useState([]);
    const [limit, setLimit] = useState(50);
    const [offset, setOffset] = useState(2);
    const [viewAllComments, setViewAllComments] = useState(true);
    const [created, setCreated] = useState(new Date(policy.createdAt));
    const [openSnack, setShowSnack] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [snackOptions, setSnackOptions] = useState({ isError: false, message: '' });
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [commentCount, setCommentCount] = useState(Number(policy.policyCommentCount));
    const [showComments, setShowComments] = useState(formSidebar ? true : false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [openEditor, setOpenEditor] = useState(false);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    function handleSnackClose() {
        setShowSnack(false);
    }

    useEffect(() => {
        let id = policy.policy_id.toString();
        let url = `/Uploads/${user.user_id}/Policies/${id}/index.html`;
        setContentUrl(`${process.env.REACT_APP_BACKEND_URL}/${url}`);
        axios
            .get(`${url}`)
            .then(({ data }) => {
                setContent(data);
            })
            .catch((err) => console.log(err));
        axios.get(`/policies/reacted/${policy.policy_id}`).then(({ data }) => {
            if (data.success) {
                setReacted(data.reacted);
                if (data.react !== null) {
                    setReaction(data.react.react.react_name);
                    if (data.react.react.react_id == 1) {
                        setReactionImg(Like);
                    } else if (data.react.react.react_id == 2) {
                        setReactionImg(Love);
                    } else if (data.react.react.react_id == 3) {
                        setReactionImg(Haha);
                    } else if (data.react.react.react_id == 4) {
                        setReactionImg(Wow);
                    } else if (data.react.react.react_id == 5) {
                        setReactionImg(Sad);
                    } else if (data.react.react.react_id == 6) {
                        setReactionImg(Angry);
                    }
                }
            }
        });
    }, []);

    function urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function (url) {
            return '<a target="_target" href="' + url + '">' + url + '</a>';
        });
    }

    const adjustReact = async () => {
        await axios
            .delete('/policy-reacts/destroy', { data: { policy_id: policy.policy_id } })
            .then(({ data }) => {
                if (data.success) {
                    setReacted(false);
                }
            })
            .catch((err) => console.log(err));
    };

    const fetchComments = async () => {
        const formData = new FormData();
        formData.append('offset', parseInt(offset));
        formData.append('limit', parseInt(limit));

        await axios.post(`/policy-comments/${policy?.policy_id}`, formData).then(({ data }) => {
            if (data.success) {
                // Only append if offset > 0 (for pagination), otherwise replace
                if (offset > 0) {
                    setComments([...comments, ...data.comments]);
                } else {
                    setComments(data.comments);
                }
                setLimit(data.count);
                setOffset(data.comments.length);
            }
        });
    };

    useEffect(() => {
        HasPermission(setCanEdit, 'Policy', 'edit', 'policy');
        HasPermission(setCanDelete, 'Policy', 'delete', 'policy');
        // Only fetch comments initially, not on every showComments change
        if (showComments && comments.length === 0) {
            fetchComments();
        }
    }, []);

    // Separate useEffect for initial comment fetch
    useEffect(() => {
        fetchComments();
    }, [showComments]);

    useEffect(() => {
        listen_to_channel();
    }, []);

    function listen_to_channel() {
        socket.on('policy_react_added', (post_id) => {
            if (post_id == policy.policy_id) {
                setReactCount((prev) => prev + 1);
            }
        });
        socket.on('policy_react_removed', (post_id) => {
            if (post_id == policy.policy_id) {
                setReactCount((prev) => prev - 1);
            }
        });
    }

    // check if the user has already seen the policy
    const currentUserId = JSON.parse(window.localStorage.getItem('authUser'))?.user_id;
    const policyUser = policy.policy_users.find((user) => user.user_id === currentUserId);
    const alreadySeen = policyUser ? policyUser.seen === true : false;

    const handleMarkAsSeen = async () => {
        try {
            const response = await axios.post('/policies/seen', {
                policy_id: Number(policy.policy_id)
            });

            if (response.data.success) {
                // Update the user's seen status in policyUsers
                const updatedPolicyUsers = policyUsers.map((user) => {
                    if (user.user_id === currentUserId) {
                        return {
                            ...user,
                            seen: true,
                            seen_at: new Date().toISOString()
                        };
                    }
                    return user;
                });

                setPolicyUsers(updatedPolicyUsers);
                setAttendenceCount((prev) => prev + 1);
            }
        } catch (error) {
            console.error('Error marking policy as seen:', error);
        }
    };

    return (
        <Box ref={policies?.length >= 5 && index === policies?.length - 1 ? lastPostRef : null} sx={{ mb: formSidebar ? 0 : 3 }}>
            <StyledCard>
                <CardContent sx={{ p: 2 }}>
                    {/* Header Section */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                        <Box display="flex" gap={1.5} alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
                            <Box display="flex" gap={1}>
                                <UserAvatarComponent userData={policy.user} size="large" sx={{ width: 52, height: 52 }} />
                                <Box>
                                    <Typography variant="h6" fontWeight={600} color="text.primary" fontSize="1">
                                        {policy.user?.first_name} {policy.user?.last_name}
                                    </Typography>
                                    <Typography color="#666" fontSize="0.9rem">
                                        {policy.user?.job_title && policy.user?.job_title.length > 0
                                            ? policy.user?.job_title[0]?.title
                                            : 'N/A'}
                                    </Typography>
                                </Box>
                            </Box>

                            <Typography variant="body2" color="#666" fontSize="0.9rem">
                                {convertDateAndTime(policy.createdAt)}
                            </Typography>
                        </Box>

                        {JSON.parse(window.localStorage.getItem('authUser'))?.user_id == policy.user_id && (
                            <IconButton onClick={handleMenuOpen} size="small" sx={{ p: 1.5, ml: 1 }}>
                                <img src={ThreeDot} alt="menu" style={{ width: 20, height: 20 }} />
                            </IconButton>
                        )}
                    </Stack>

                    {/* Content Section */}
                    <Box mb={2}>
                        <Typography variant="h4" fontWeight={600} mb={1} color="text.primary" fontSize="1.2rem" lineHeight={1.3}>
                            {policy.policy_title}
                        </Typography>

                        <Typography
                            variant="body1"
                            color="#666"
                            lineHeight={1.7}
                            fontSize="1rem"
                            sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                        >
                            {urlify(policy.plain_text_body).length > 150 ? (
                                <>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: showMore
                                                ? urlify(policy.plain_text_body)
                                                : `${urlify(policy.plain_text_body).substring(0, 150)}...`
                                        }}
                                    />
                                    <Button
                                        variant="text"
                                        size="small"
                                        onClick={() => {
                                            if (!alreadySeen) {
                                                submitResponse(true);
                                            }

                                            setShowMore(!showMore);
                                        }}
                                        sx={{
                                            ml: 1,
                                            textTransform: 'none',
                                            color: '#1E7C88',
                                            fontWeight: 600,
                                            fontSize: '0.9rem'
                                        }}
                                    >
                                        {showMore ? 'Show less' : 'Show more'}
                                    </Button>
                                </>
                            ) : (
                                <span dangerouslySetInnerHTML={{ __html: urlify(policy.plain_text_body) }} />
                            )}
                        </Typography>
                    </Box>

                    {/* Attachments */}
                    {policy.attachemts && policy.attachemts.length > 0 && (
                        <Stack spacing={2} mb={2}>
                            {policy.attachemts.map((attachemt, idx) => (
                                <AttachmentBox
                                    key={idx}
                                    onClick={() => {
                                        if (!alreadySeen) {
                                            submitResponse(true);
                                        }
                                        downloadFile(`${attachemt.url}`);
                                    }}
                                    sx={{ cursor: 'pointer', opacity: 1 }}
                                    title="Download attachment"
                                >
                                    <img src={PdfIcon} width={28} height={28} alt="attachment" />
                                    <Typography variant="body1" ml={2} color="text.primary" fontWeight={500} fontSize="1rem">
                                        {attachemt.name}
                                    </Typography>
                                </AttachmentBox>
                            ))}
                        </Stack>
                    )}

                    {/* Progress Section */}
                    <Box mb={2}>
                        <Box mb={2}>
                            <BorderLinearProgress variant="determinate" value={percent} />
                        </Box>

                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                onClick={() => setShowParticipants(!showParticipants)}
                                sx={{ cursor: 'pointer', transition: 'opacity 0.2s', '&:hover': { opacity: 0.8 } }}
                            >
                                <AvatarGroup max={3} sx={{ '& .MuiAvatar-root': { width: 36, height: 36, fontSize: '0.9rem' } }}>
                                    {policyUsers.slice(0, 3).map((user, idx) => (
                                        <Avatar key={idx} src={user.profile_image} alt={user.first_name} />
                                    ))}
                                </AvatarGroup>
                                <Typography variant="body1" color="text.secondary" fontSize="1rem" fontWeight={500}>
                                    Seen {attendenceCount} of {policyUsers.length}
                                </Typography>
                            </Stack>

                            <Stack direction="row" spacing={1.5} alignItems="center">
                                {!alreadySeen && (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        onClick={handleMarkAsSeen}
                                        sx={{
                                            backgroundColor: '#1E7C88',
                                            color: '#fff',
                                            fontSize: '0.875rem',
                                            fontWeight: 600,
                                            textTransform: 'none',
                                            px: 2.5,
                                            py: 0.75,
                                            borderRadius: 1.5,
                                            '&:hover': {
                                                backgroundColor: '#176B75'
                                            }
                                        }}
                                    >
                                        Mark as Seen
                                    </Button>
                                )}
                                <Chip
                                    label={`${policyUsers.length - attendenceCount} remaining`}
                                    size="medium"
                                    variant="outlined"
                                    color="primary"
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '0.85rem',
                                        borderRadius: 1.5,
                                        px: 1.5,
                                        py: 2
                                    }}
                                />
                            </Stack>
                        </Stack>
                    </Box>

                    {/* Actions Section */}
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction="row" spacing={3}>
                            {/* React Button with Hover */}
                            <Box sx={{ position: 'relative' }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        cursor: 'pointer',
                                        py: 1
                                    }}
                                    onMouseEnter={() => setReactOpen(true)}
                                    onMouseLeave={() => setReactOpen(false)}
                                    onClick={() => {
                                        adjustReact();
                                    }}
                                >
                                    <img src={reacted ? reactionImg : Blank} alt="react" style={{ width: 20, height: 20 }} />
                                    <Typography
                                        sx={{
                                            color: reacted ? '#1E7C88' : '#666',
                                            fontWeight: reacted ? 600 : 500,
                                            fontSize: '0.9rem'
                                        }}
                                    >
                                        {reacted ? reaction : 'Like'}
                                    </Typography>
                                </Box>

                                {reactOpen && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: -65,
                                            left: 0,
                                            zIndex: 1024,
                                            width: 320
                                        }}
                                        onMouseEnter={() => setReactOpen(true)}
                                        onMouseLeave={() => setReactOpen(false)}
                                    >
                                        <Reacts
                                            modelValue={policy}
                                            reacts={reacts}
                                            setReactOpen={setReactOpen}
                                            setReacted={setReacted}
                                            setReactCount={setReactCount}
                                            setReactionImg={setReactionImg}
                                            setReaction={setReaction}
                                            model={'policy'}
                                        />
                                    </Box>
                                )}
                            </Box>

                            {/* Comment Button */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    cursor: 'pointer',
                                    py: 1
                                }}
                                onClick={() => setCommentOpen(!commentOpen)}
                            >
                                <img src={Comment} alt="comment" style={{ width: 20, height: 20 }} />
                                <Typography
                                    sx={{
                                        color: '#666',
                                        fontWeight: 500,
                                        fontSize: '0.9rem'
                                    }}
                                >
                                    Comment
                                </Typography>
                            </Box>
                        </Stack>

                        <Button
                            variant="text"
                            size="medium"
                            onClick={() => setShowComments(!showComments)}
                            sx={{
                                textTransform: 'none',
                                color: 'text.secondary',
                                fontSize: '0.9rem',
                                '&:hover': { color: '#1E7C88' }
                            }}
                        >
                            {commentCount} Comments
                        </Button>
                    </Stack>

                    {/* Reactions Summary */}
                    {(reactCount > 0 || reacted) && (
                        <Typography
                            variant="body1"
                            sx={{
                                cursor: 'pointer',
                                fontSize: '1rem',
                                mt: 1,
                                color: '#666'
                            }}
                            onClick={() => setOpenViewReactModal(true)}
                        >
                            {reacted && <span style={{ fontWeight: 600 }}>You</span>}
                            {reacted && reactCount > 0 && ' and '}
                            {reactCount > 0 && (
                                <span style={{ fontWeight: 600 }}>
                                    {reactCount} {reactCount === 1 ? 'other' : 'others'}
                                </span>
                            )}
                            {' reacted to this policy'}
                        </Typography>
                    )}

                    {/* Comment Input */}
                    {commentOpen && (
                        <Box mt={3}>
                            <CreateComment
                                setComments={setComments}
                                comments={comments}
                                post={policy}
                                placeholder={'Write Comment ...'}
                                model={'policy'}
                                showSnack={(isError, message) => {
                                    setSnackOptions({ isError, message });
                                    setShowSnack(true);
                                }}
                                setCommentCount={setCommentCount}
                            />
                        </Box>
                    )}

                    {/* Comments List */}
                    {showComments && comments.length > 0 && (
                        <Box mt={3}>
                            <Stack spacing={2.5}>
                                {comments.map((comment, idx) => (
                                    <PolicyCommentBox
                                        key={idx}
                                        setComments={setComments}
                                        setCommentCount={setCommentCount}
                                        comment={comment}
                                        type="policy"
                                    />
                                ))}
                            </Stack>
                        </Box>
                    )}
                </CardContent>
            </StyledCard>

            {/* Menu */}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {canEdit && (
                    <MenuItem
                        onClick={() => {
                            setOpenEditor(true);
                            handleMenuClose();
                        }}
                    >
                        Edit
                    </MenuItem>
                )}
                {canDelete && (
                    <MenuItem
                        onClick={() => {
                            setOpenDeleteModal(true);
                            handleMenuClose();
                        }}
                    >
                        Delete
                    </MenuItem>
                )}
            </Menu>

            {/* Modals */}
            {showParticipants && (
                <Modal open={showParticipants} onClose={() => setShowParticipants(false)}>
                    <PolicyViewers policyUsers={policyUsers} setShowParticipants={setShowParticipants} />
                </Modal>
            )}

            {openDeleteModal && (
                <Modal open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                    <DeleteModal
                        setOpenDeleteModal={setOpenDeleteModal}
                        url={`/policies/delete`}
                        id={policy.policy_id}
                        showSnack={(isError, message) => {
                            setSnackOptions({ isError, message });
                            setShowSnack(true);
                        }}
                        setPosts={setPolicies}
                        model={`policy`}
                    />
                </Modal>
            )}

            {openEditor && (
                <Modal open={openEditor} onClose={() => setOpenEditor(false)}>
                    <CreatePolicy
                        setOpenModal={setOpenEditor}
                        policy={policy}
                        setPolicies={setPolicies}
                        showSnack={(isError, message) => {
                            setSnackOptions({ isError, message });
                            setShowSnack(true);
                        }}
                    />
                </Modal>
            )}

            {openViewReactModal && (
                <ViewReactModal
                    post={policy}
                    type="policy"
                    endpoint="/policy-reacts/list"
                    setOpenModal={setOpenViewReactModal}
                    openModal={openViewReactModal}
                />
            )}

            <Snackbar
                open={openSnack}
                autoHideDuration={5000}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackClose} severity={snackOptions.isError ? 'error' : 'success'}>
                    {snackOptions.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default Policy;
